/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, TemplateRef } from "@angular/core";
var WizardPageNavTitleDirective = (function () {
    function WizardPageNavTitleDirective(pageNavTitleTemplateRef) {
        this.pageNavTitleTemplateRef = pageNavTitleTemplateRef;
    }
    return WizardPageNavTitleDirective;
}());
export { WizardPageNavTitleDirective };
WizardPageNavTitleDirective.decorators = [
    { type: Directive, args: [{
                selector: "[clrPageNavTitle]"
            },] },
];
/** @nocollapse */
WizardPageNavTitleDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };
//# sourceMappingURL=page-navtitle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/directives/page-navtitle.js
// module id = 99
// module chunks = 4